import { render, staticRenderFns } from "./TTLEditor.vue?vue&type=template&id=5d80f0e9&scoped=true"
import script from "./TTLEditor.vue?vue&type=script&lang=js"
export * from "./TTLEditor.vue?vue&type=script&lang=js"
import style0 from "./TTLEditor.vue?vue&type=style&index=0&id=5d80f0e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d80f0e9",
  null
  
)

export default component.exports